import { createTheme } from "@mui/material/styles";

export const redTheme = createTheme({
    palette: { primary: { main: "#E60D2E" } },
});
export const blueTheme = createTheme({
    palette: { primary: { main: "#005EB8" } },
});
export const greyTheme = createTheme({
    palette: { primary: { main: "#F5F5F5" } },
});
export const greenTheme = createTheme({
    palette: { primary: { main: '#84BD00' } },
});

export const disabledPrimary = createTheme({
    palette: {
        action: {
            disabledBackground: "#005EB8",
            disabled: "#F5F5F5",
        },
    },
});

export const disabledSecondary = createTheme({
    palette: {
        action: {
            disabledBackground: "#E60D2E",
            disabled: "#F5F5F5",
        },
    },
});

export const appTheme = createTheme({

    palette: {
        primary: {
            main: "#005EB8"
        }
    },
    components: {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    h1: 'h1',
                    h2: 'h2',
                    h3: 'h3',
                    h4: 'h4',
                    h5: 'h5',
                    h6: 'h6',
                    subtitle1: 'h2',
                    subtitle2: 'h2',
                    body1: 'span',
                    body2: 'span',
                },
            },
        },
        // Name of the component
        MuiButtonBase: {
            defaultProps: {
                // The props to change the default for.
                disableRipple: true, // No more ripple!
            },
        },
        // Name of the component
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    // Some CSS
                    fontSize: '1rem',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: "bold",
                },
                footer: {
                    fontWeight: "bold",
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                selectLabel: {
                    fontWeight: "bold",
                },
                select: {
                    fontWeight: "bold",
                },
                displayedRows: {
                    fontWeight: "bold",
                }

            }
        },
        MuiInput: {
            styleOverrides: {
                input: {
                    ":disabled": {
                        WebkitTextFillColor: "black",
                    }
                },
            }

        },
        MuiSelect: {
            styleOverrides: {
                standard: {
                    '&.Mui-disabled': {
                        WebkitTextFillColor: "black",
                    },
                   
                },
            }
        },
        
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});
